module.exports = __webpack_public_path__ + "img/logo-full-wompi.ba902011.png";